import type { SelectableItem, ProductBundle } from '~/models/CampaignModel';
import { calculateSavingsFirstYear } from '../basket/basket.helpers';

const isDiscountedOffer = (offer: SelectableItem) => calculateSavingsFirstYear(offer.pricing) > 0;

const containsCommercialProduct = (offerList: SelectableItem[], currentOffer: any) =>
  !!offerList.find((offer) => offer.offer.commercialProductId === currentOffer.offer.commercialProductId);

const containsCompositeProduct = (offerList: SelectableItem[], currentOffer: any) =>
  !!offerList.find((offer) => offer.offer.compositeId === currentOffer.offer.compositeId);

// TODO: unit test "getVisibleBestDiscountOffers"
export const getVisibleBestDiscountOffers = <T extends SelectableItem = SelectableItem>(
  selectedInBundle: T[],
  bundle: ProductBundle<T>,
) => {
  const maxDiscountedItems = bundle.selectionConfig.maxDiscountedItems;
  const filteredOffers: T[] = [];

  // Get a unique list of commercialProductIds from the bundles.
  const originalProductOrder = bundle.offers
    .map((offer) => offer.offer.commercialProductId)
    .filter((value, index, arr) => arr.indexOf(value) === index);

  // Remap & sort by savings
  const bundleOffers = bundle.offers.slice();

  bundleOffers.sort((a, b) => calculateSavingsFirstYear(b.pricing) - calculateSavingsFirstYear(a.pricing));

  // Item limit
  const currentDiscountedItems = selectedInBundle.filter((offer) => isDiscountedOffer(offer)) || [];
  const hasReachedDiscountLimit = currentDiscountedItems.length >= maxDiscountedItems;

  // Get one offer for each commercial product
  // 1. If it is single offer, display this offer
  // 2. If the offer is in basket, display this offer
  // 3. If the offer is discounted and limit is not reached, display discounted offer
  // 4. If the limit is reached, display normal offer
  for (const commercialProductId of originalProductOrder) {
    const productSubset = bundleOffers.filter((offer) => offer.offer.commercialProductId === commercialProductId);
    for (const offer of productSubset) {
      const isSingleOffer = productSubset.length === 1;
      const selectedThisOffer = containsCompositeProduct(selectedInBundle, offer);
      const selectedThisProduct = containsCommercialProduct(selectedInBundle, offer);
      if (
        isSingleOffer ||
        selectedThisOffer ||
        (isDiscountedOffer(offer) && !hasReachedDiscountLimit) ||
        (!isDiscountedOffer(offer) && hasReachedDiscountLimit && !selectedThisProduct)
      ) {
        filteredOffers.push(offer);
        break;
      }
    }
  }
  return filteredOffers;
};
